<template>
  <layout name="Settings">
    <div>
      <VSettingsSidebarLayoutHeading title="Return Address" />

      <div class="org-address-form__wrapper">
        <AccountAddressForm />
      </div>
    </div>
  </layout>
</template>

<script>
import Vue from "vue";
import Layout from "@/layouts/Layout";

import AccountAddressForm from "@/components/AccountAddressForm";
import VSettingsSidebarLayoutHeading from "@/components/VSettingsSidebarLayoutHeading";

export default Vue.component("AccountUser", {
  metaInfo: {
    title: "Settings - Return Address"
  },

  components: {
    Layout,
    VSettingsSidebarLayoutHeading,
    AccountAddressForm
  }
});
</script>

<style lang="scss" scoped></style>
